'use client';

import type { FilterCategory } from '@/lib/projects';
import { FILTER_TABS } from '@/lib/projects';

type Props = {
  value: FilterCategory;
  onChange: (v: FilterCategory) => void;
  counts: Record<FilterCategory, number>;
};

export function ProjectFilters({ value, onChange, counts }: Props) {
  return (
    <div
      role="tablist"
      aria-label="Filter projects by category"
      className="mx-auto flex flex-wrap items-center justify-center gap-2"
    >
      {FILTER_TABS.map((tab) => {
        const active = tab.value === value;
        const count = counts[tab.value] ?? 0;
        if (count === 0 && tab.value !== 'all') return null;
        return (
          <button
            key={tab.value}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.value)}
            className="font-mono transition-all duration-300 rounded-full"
            style={{
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: '0.06em',
              padding: '8px 16px',
              border: `1px solid ${active ? 'var(--accent-mid)' : 'var(--border)'}`,
              background: active ? 'var(--accent-dim)' : 'transparent',
              color: active ? 'var(--accent)' : 'var(--text-muted)',
              textTransform: 'uppercase',
            }}
            onMouseEnter={(e) => {
              if (!active) e.currentTarget.style.borderColor = 'var(--border-hover)';
            }}
            onMouseLeave={(e) => {
              if (!active) e.currentTarget.style.borderColor = 'var(--border)';
            }}
          >
            {tab.label}
            {tab.value === 'all' && (
              <span
                className="ml-1.5"
                style={{ color: active ? 'var(--accent)' : 'var(--text-caption)' }}
              >
                ({count})
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
